export default "__VITE_ASSET__fkjLzqtx__"